export default __webpack_public_path__ + "static/media/abvSearchIcon.33ec50bf.svg";